/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';

/**
 * 
 * @export
 * @interface CreateTimeEntryTypeRequest
 */
export interface CreateTimeEntryTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryTypeRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryTypeRequest
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTimeEntryTypeRequest
     */
    isActive?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTimeEntryTypeRequest
     */
    useEmployeePayRate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTimeEntryTypeRequest
     */
    useAppointmentPayRate?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateTimeEntryTypeRequest
     */
    percentage?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateTimeEntryTypeRequest
     */
    hourlyPayRate?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTimeEntryTypeRequest
     */
    roles?: Array<string> | null;
}

/**
 * Check if a given object implements the CreateTimeEntryTypeRequest interface.
 */
export function instanceOfCreateTimeEntryTypeRequest(value: object): value is CreateTimeEntryTypeRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateTimeEntryTypeRequestFromJSON(json: any): CreateTimeEntryTypeRequest {
    return CreateTimeEntryTypeRequestFromJSONTyped(json, false);
}

export function CreateTimeEntryTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTimeEntryTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'useEmployeePayRate': json['useEmployeePayRate'] == null ? undefined : json['useEmployeePayRate'],
        'useAppointmentPayRate': json['useAppointmentPayRate'] == null ? undefined : json['useAppointmentPayRate'],
        'percentage': json['percentage'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['percentage']),
        'hourlyPayRate': json['hourlyPayRate'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['hourlyPayRate']),
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function CreateTimeEntryTypeRequestToJSON(json: any): CreateTimeEntryTypeRequest {
    return CreateTimeEntryTypeRequestToJSONTyped(json, false);
}

export function CreateTimeEntryTypeRequestToJSONTyped(value?: CreateTimeEntryTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
        'useEmployeePayRate': value['useEmployeePayRate'],
        'useAppointmentPayRate': value['useAppointmentPayRate'],
        'percentage': BalanceUnitStatementEntryDebitToJSON(value['percentage']),
        'hourlyPayRate': BalanceUnitStatementEntryDebitToJSON(value['hourlyPayRate']),
        'roles': value['roles'],
    };
}

